import { ComponentConfig } from "@measured/puck";

import RichTextEditorField from "../../fields/RichTextEditorField";
import { AiCommentBlock, type AiCommentBlockProps } from "./AiCommentBlock";

export type { AiCommentBlockProps };

export const AiCommentConfig: ComponentConfig<AiCommentBlockProps> = {
    label: "AI Comment",
    fields: {
        editorialPrompt: {
            type: "custom",
            label: "Editorial prompt",
            render: (fieldProps) => <RichTextEditorField {...fieldProps} />,
        },
    },
    defaultProps: {
        editorialPrompt: "Write a short narrative comment for {company.name} using only the provided values.",
    },
    render: ({ puck, ...props }) => <AiCommentBlock {...props} isEditing={puck.isEditing} />,
};

export default AiCommentConfig;
